import { Bar } from "react-chartjs-2";
import ChartContainer from './chartContainer';

const AverageHoursBarChart = ({data}) => {
    const labels = data.map(item => item.name);
    const chartData = {
        labels: labels,
        datasets: data.map(item => ({
          data: [item],
          label: item.name,
          maxBarThickness: 20,
          stack: 'bar',
          parsing: {
            xAxisKey: 'name',
            yAxisKey: 'value',
        }}))
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                title: 'Average Hours By Period',
                beginAtZero: true,
                suggestedMin: 0,
                suggestedMax: 1,
                ticks: {
                    autoSkip: false,
                    precision: 0,
                }
            },
            x: {
                grid: {
                    drawOnChartArea: false,
                },
            },
        },
        plugins: {
            title: {
                display: true,
                position: 'top',
                color: 'black',
                text: 'Average Hours By Period',
                font: {
                    size: 20,
                    family: "work-Sans, sans-serif",
                }
            },
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: (Item) => `${Item.label}: ${Item.formattedValue}`,
                }
            },
        },
    }

    return (
        <ChartContainer>
            <Bar data={chartData} options={options}/>
        </ChartContainer>

    )
}

export default AverageHoursBarChart;